module.exports = __webpack_public_path__ + "static/media/milestone-green.949b113d.svg";